import React from "react"
import { Layout } from 'antd'
import HomePage from './Home'
import ItemDataPage from "./ItemData"
import { VERSION } from "../../static/constant"
const IndexPage = () => {

	return (
		<Layout style={{backgroundColor: '#F0F2F5',minWidth:'1440px',minHeight: '100vh',}}>
			<Layout.Content >
				<HomePage />
				<ItemDataPage />
			</Layout.Content>
			<Layout.Footer style={{ height:'117px'}}>
				<div style={{marginTop:'63px'}}>
					<span style={{ marginLeft: '40px', marginBotton: '6px', fontSize: '16px' ,lineHeight: '24px'}}>
						{VERSION}</span>
				</div>
			</Layout.Footer>
		</Layout>

	)
}


export default IndexPage
